export const actions = {
  SELECTION: 'selection',
  RECT: 'rect',
  CIRCLE: 'circle',
  FARROW: 'filledArrow',
  BDFARROW: 'bidirectionalFilledArrow',
  DASHEDARROW: 'dashedArrow',
  BDDASHEDARROW: 'bidirectionalDashedArrow',
  LINE: 'line',
  ARROW: 'arrow',
  BDARROW: 'bidirectionalArrow',
  EYE: 'eye',
  NAVIGATE: 'navigate',
  TEXT: 'text'
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/models.js